export const ADMINISTRATIVE_ROLES = [
  "super admin",
  "super admin +",
  "company admin",
];

export const isAdministrativeRole = (role) =>
  ADMINISTRATIVE_ROLES.includes(String(role || "").trim().toLowerCase());

export const getPasswordChecks = (value = "") => {
  const passwordChecks = {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: /[!@#$%^&*]/.test(value),
  };

  return passwordChecks;
};

export const isStrongPassword = (value) =>
  Object.values(getPasswordChecks(value)).every(Boolean);
